var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditPdf = function SvgEditPdf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33334 4C4.33334 3.44772 4.78106 3 5.33334 3H15.8619L19.6667 6.80474V20C19.6667 20.5523 19.219 21 18.6667 21H5.33334C4.78106 21 4.33334 20.5523 4.33334 20V4Z",
    stroke: "var(--iconColor, currentColor)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 15.2813V17.625H8.71875L15.6312 10.7125L13.2875 8.36876L6.375 15.2813ZM17.4437 8.90001C17.6875 8.65626 17.6875 8.26251 17.4437 8.01876L15.9813 6.55626C15.7375 6.31251 15.3437 6.31251 15.1 6.55626L13.9563 7.70001L16.3 10.0438L17.4437 8.90001V8.90001Z",
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditPdf);
export { ForwardRef as ReactComponent };